import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const VisionariosSection = () => {
  return (
    <section className=" py-10 md:py-24 ">
      <div className="container">
        <div className="rounded-xl md:rounded-full bg-white md:mb-16 mb-4 p-5 shadow-md md:shadow-lg ">
          <h3
            className="text-center  text-n-primary md:text-[100px] text-4xl md:my-10"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            Visionários desde 2010
          </h3>
        </div>
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-5xl ">
              Redirecionamos a trajetória do transporte de veículos no Brasil.
            </h2>
            <p className="md:text-lg text-n-text-neutral mb-6">
              A quinze anos acreditamos que o transporte de veículos pode ser
              feito de uma maneira diferente, melhor, mais eficiente e com maior
              grau de satisfação pelo cliente. Nossa jornada teve origem no
              mercado tradicional de transportes, mas o espírito inovador nos
              permitiu encontrar soluções diferenciadas e adequadas ao mundo
              contemporâneo.
            </p>

            <Link to="/fazer-cotacao">
              <Button>
                Fazer Cotação
                <ArrowRight className=" h-6 w-6" />
              </Button>
            </Link>
          </div>

          <div className="flex items-center justify-center">
            <ImageSvg
              src="redirecionamos.svg"
              alt="Rede nacional de pontos de apoio"
              className="max-w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
